import { ErrorBoundary as SentryErrorBoundary } from '@sentry/react'
import { PropsWithChildren } from 'react'
import { Fallback } from '~/components/ErrorBoundary/components/Fallback'

export function ErrorBoundary({ children }: PropsWithChildren) {
  return <SentryErrorBoundary fallback={Fallback}>{children}</SentryErrorBoundary>
}
